<!--suppress HtmlUnknownTag -->
<vuejs3-todo>
    Event emission model must be updated
</vuejs3-todo>

<template>
    <label :class="['app-toggle', checked ? 'checked' : null, disabled ? 'disabled' : null]">
        <input type="checkbox"
               :checked="checked"
               @click.stop="$emit('change', $event.target.checked)"
               :disabled="disabled"
        />
        <span></span>
    </label>
</template>

<script>
    export default {
        model: {
            prop: "checked",
            event: "change"
        },
        name: "AppToggle",
        props: {
            checked: Boolean,
            disabled: Boolean
        }
    }
</script>

<style lang="scss">
    @import "../../mixins";
    @import "../../colors";

    .app-toggle {
        --height: 24px;

        position: relative;
        display: inline-block;
        width: calc(var(--height) * 1.5);
        height: var(--height);
        padding: 1px;
        text-align: left;
        box-sizing: border-box;
        background-color: $color-border;
        border-radius: calc(var(--height) / 2);
        cursor: pointer;
        @include transition(background-color);

        &.checked {
            background-color: $color-mint;

            & > span {
                left: calc(var(--height) / 2);
            }
        }

        &.disabled {
            cursor: not-allowed;
        }

        &.disabled.checked {
            background-color: $color-green-light;
        }

        & > input {
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
            margin: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            cursor: inherit;
        }

        & > span {
            position: relative;
            left: 0;
            vertical-align: top;
            height: calc(var(--height) - 2px);
            width: calc(var(--height) - 2px);
            border-radius: 50%;
            background-color: white;
            display: inline-block;
            box-shadow: 0 0 2px $color-backdrop;
            @include transition(left);
        }
    }
</style>
